"use client"

import { cn } from "@rarible_int/anaconda_ui_components"
import { useCallback } from "react"

interface Props {
  slideActive: boolean
  withTimer: boolean
  timerDurationInSeconds: number
  onClick: () => void
}

export function MobileSlidePreview({
  slideActive,
  withTimer,
  timerDurationInSeconds,
  onClick,
}: Props) {
  const handleClick = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      e.preventDefault()
      onClick()
    },
    [onClick],
  )

  return (
    <button
      type="button"
      onClick={handleClick}
      className={cn("relative h-0 w-12 rounded-sm border-2 border-white/20")}
    >
      {withTimer && slideActive && (
        <Timer
          durationInSeconds={timerDurationInSeconds}
          className="absolute inset-0 translate-y-[-2px]"
        />
      )}
    </button>
  )
}

function Timer({
  durationInSeconds = 5,
  className,
}: {
  durationInSeconds?: number
  className?: string
}) {
  return (
    <div
      style={{ animationDuration: `${durationInSeconds}s` }}
      className={cn(
        "h-0 animate-[width-expand_linear_forwards] rounded-sm border-2 border-white",
        className,
      )}
    />
  )
}
